// extracted by css-extract-rspack-plugin
export default {"JoinCell":"Q4ZlB","JoinConditionCell":"epUO7"};